import Component from 'vue-class-component'
import Vue from 'vue'
import { Reference } from '@/model/reference'
import * as normalizeUrl from 'normalize-url'
import LinkPrevue from 'link-prevue'

@Component({
  name: 'referencePreview',
  props: ['reference'],
  components: {'link-prevue': LinkPrevue}
})
export default class ReferencePreview extends Vue {
  protected preview: {
    url?: string|null,
    image?: {
      url: string,
      width: string,
      height: string,
      type: string
    },
    title?: string|null,
    description?: string|null
  } = {}

  getReference(): Reference|null {return this.$props['reference']}

  protected normalize (url: string): string {
    console.log('normalize: url = %j', url)
    return normalizeUrl(url)
  }

  protected truncate (text: string, length: number): string {
    if(text.length <= length) return text
    return text.substring(0, length-3) + "..."
  }
}
